(function () {
  // Shopify endpoints need the active locale root ("/" or "/de/") in front of
  // them. A bare "/cart.js" resets the session to the domain defaults, which
  // throws the visitor back into the primary market — Shopify warns about this
  // exact case for hardcoded URLs in links and Ajax requests.
  function shopifyUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function init(container) {
    if (!container || container.dataset.etUpgradeInit) return;
    container.dataset.etUpgradeInit = 'true';

    var settings = JSON.parse(container.querySelector('[data-et-upgrade-settings]').textContent);
    var minRequired = settings.min_required || 3;
    var multiSelect = settings.multi_select !== false;
    var maxSelectable = settings.max_selectable || 10;
    var discountLabel = settings.discount_label || 'Korting';
    var totalLabel = settings.total_label || 'Total';
    var ctaText = settings.cta_text || 'Add to cart';
    var currencySymbol = settings.currency_symbol || '€';
    var mainProductPrice = settings.main_product_price || 0;
    var mainProductTitle = settings.main_product_title || '';
    var mainProductVariantId = settings.main_product_variant_id || 0;

    var selectedItems = [];
    var selectedSetUpgrade = null;
    var activeTab = container.querySelector('.et-upgrade__tab--active');
    var activeTabKey = activeTab ? activeTab.dataset.tab : 'tab_1';

    var tabs = container.querySelectorAll('.et-upgrade__tab');
    var productLists = container.querySelectorAll('.et-upgrade__product-list');
    var priceLinesEl = container.querySelector('[data-price-lines]');
    var totalValueEl = container.querySelector('[data-total-value]');
    var ctaBtn = container.querySelector('[data-cta-btn]');
    var validationMsg = container.querySelector('[data-validation-msg]');
    var slots = container.querySelectorAll('.et-upgrade__summary-slot');
    var mainImageEl = container.querySelector('[data-main-image]');
    var originalMainImageSrc = mainImageEl ? mainImageEl.src : '';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      var locale = (window.Shopify && window.Shopify.locale || document.documentElement.lang || '').toLowerCase();
      if (locale.indexOf('fr') === 0 || locale.indexOf('de') === 0) return amount + currencySymbol;
      return currencySymbol + amount;
    }

    function switchTab(tabKey) {
      activeTabKey = tabKey;
      tabs.forEach(function (t) {
        t.classList.toggle('et-upgrade__tab--active', t.dataset.tab === tabKey);
      });
      productLists.forEach(function (list) {
        list.classList.toggle('et-upgrade__product-list--active', list.dataset.tabList === tabKey);
      });
    }

    function addItem(productEl) {
      var id = productEl.dataset.productId;
      if (selectedItems.find(function (i) { return i.id === id; })) return;
      if (!multiSelect && selectedItems.length >= 1) return;
      if (selectedItems.length >= maxSelectable) return;

      selectedItems.push({
        id: id,
        variantId: productEl.dataset.variantId,
        title: productEl.dataset.productTitle,
        price: parseInt(productEl.dataset.productPrice, 10),
        comparePrice: parseInt(productEl.dataset.comparePrice, 10) || 0,
        image: productEl.dataset.productImage
      });

      updateProductButtons();
      updateSummary();
    }

    function removeItem(id) {
      selectedItems = selectedItems.filter(function (i) { return i.id !== id; });
      updateProductButtons();
      updateSummary();
    }

    function selectSetUpgrade(productEl) {
      selectedSetUpgrade = {
        id: productEl.dataset.productId,
        variantId: productEl.dataset.variantId,
        title: productEl.dataset.productTitle,
        price: parseInt(productEl.dataset.productPrice, 10),
        comparePrice: parseInt(productEl.dataset.comparePrice, 10) || 0,
        image: productEl.dataset.productImage
      };
      updateSetUpgradeButtons();
      updateSummary();
    }

    function clearSetUpgrade() {
      selectedSetUpgrade = null;
      updateSetUpgradeButtons();
      updateSummary();
    }

    function updateProductButtons() {
      var products = container.querySelectorAll('.et-upgrade__product[data-tab-type="also_bought"]');
      products.forEach(function (p) {
        var id = p.dataset.productId;
        var isSelected = selectedItems.find(function (i) { return i.id === id; });
        var addBtn = p.querySelector('.et-upgrade__add-btn');
        var removeBtn = p.querySelector('.et-upgrade__remove-btn');
        if (addBtn) addBtn.style.display = isSelected ? 'none' : 'flex';
        if (removeBtn) removeBtn.style.display = isSelected ? 'flex' : 'none';
      });
    }

    function updateSetUpgradeButtons() {
      var products = container.querySelectorAll('.et-upgrade__product[data-tab-type="set_upgrade"]');
      products.forEach(function (p) {
        var id = p.dataset.productId;
        var isSelected = selectedSetUpgrade && selectedSetUpgrade.id === id;
        var upgradeBtn = p.querySelector('.et-upgrade__upgrade-btn');
        var backBtn = p.querySelector('.et-upgrade__back-btn');
        if (upgradeBtn) upgradeBtn.style.display = isSelected ? 'none' : 'flex';
        if (backBtn) backBtn.style.display = isSelected ? 'flex' : 'none';
      });
    }

    function updateSummary() {
      updateSlots();
      updatePriceLines();
      updateCta();
    }

    function updateSlots() {
      slots.forEach(function (slot, index) {
        var item = selectedItems[index];
        var imgEl = slot.querySelector('.et-upgrade__slot-image');
        var removeBtn = slot.querySelector('.et-upgrade__slot-remove');
        var plusIcon = slot.querySelector('.et-upgrade__slot-plus');

        if (item) {
          slot.classList.add('et-upgrade__summary-slot--filled');
          if (imgEl) {
            imgEl.src = item.image;
            imgEl.alt = item.title;
            imgEl.style.display = 'block';
          }
          if (removeBtn) {
            removeBtn.style.display = 'flex';
            removeBtn.dataset.removeId = item.id;
          }
          if (plusIcon) plusIcon.style.display = 'none';
        } else {
          slot.classList.remove('et-upgrade__summary-slot--filled');
          if (imgEl) imgEl.style.display = 'none';
          if (removeBtn) removeBtn.style.display = 'none';
          if (plusIcon) plusIcon.style.display = 'flex';
        }
      });

      if (mainImageEl) {
        if (selectedSetUpgrade && selectedSetUpgrade.image) {
          mainImageEl.src = selectedSetUpgrade.image;
        } else {
          mainImageEl.src = originalMainImageSrc;
        }
      }
    }

    function updatePriceLines() {
      if (!priceLinesEl) return;
      var html = '';

      if (selectedSetUpgrade) {
        html += '<div class="et-upgrade__price-line">';
        html += '<span>' + escapeHtml(selectedSetUpgrade.title) + '</span>';
        html += '<span>' + formatMoney(selectedSetUpgrade.price) + '</span>';
        html += '</div>';
      } else {
        html += '<div class="et-upgrade__price-line">';
        html += '<span>' + escapeHtml(mainProductTitle) + '</span>';
        html += '<span>' + formatMoney(mainProductPrice) + '</span>';
        html += '</div>';
      }

      selectedItems.forEach(function (item) {
        html += '<div class="et-upgrade__price-line">';
        html += '<span>' + escapeHtml(item.title) + '</span>';
        html += '<span>' + formatMoney(item.price) + '</span>';
        html += '</div>';
      });

      var totalDiscount = 0;
      selectedItems.forEach(function (item) {
        if (item.comparePrice > item.price) {
          totalDiscount += item.comparePrice - item.price;
        }
      });
      if (selectedSetUpgrade && selectedSetUpgrade.comparePrice > selectedSetUpgrade.price) {
        totalDiscount += selectedSetUpgrade.comparePrice - selectedSetUpgrade.price;
      }

      if (totalDiscount > 0) {
        html += '<div class="et-upgrade__price-line et-upgrade__price-line--discount">';
        html += '<span>' + escapeHtml(discountLabel) + '</span>';
        html += '<span>- ' + formatMoney(totalDiscount) + '</span>';
        html += '</div>';
      }

      priceLinesEl.innerHTML = html;

      var total = selectedSetUpgrade ? selectedSetUpgrade.price : mainProductPrice;
      selectedItems.forEach(function (item) { total += item.price; });

      if (totalValueEl) totalValueEl.textContent = formatMoney(total);
      if (ctaBtn) {
        var ctaTextEl = ctaBtn.querySelector('[data-cta-text]');
        if (ctaTextEl) ctaTextEl.textContent = ctaText + ' - ' + formatMoney(total);
      }
    }

    function updateCta() {
      if (!ctaBtn) return;
      var isDisabled;
      if (selectedSetUpgrade) {
        isDisabled = false;
      } else {
        var totalSelected = selectedItems.length;
        isDisabled = totalSelected < minRequired;
      }
      ctaBtn.classList.toggle('et-upgrade__cta--disabled', isDisabled);
      ctaBtn.disabled = isDisabled;

      if (validationMsg) {
        validationMsg.classList.toggle('et-upgrade__validation-msg--visible', false);
      }
    }

    function handleCtaClick() {
      if (!selectedSetUpgrade) {
        var totalSelected = selectedItems.length;
        if (totalSelected < minRequired) {
          if (validationMsg) {
            validationMsg.textContent = validationMsg.dataset.msg.replace('MINIMUM', minRequired);
            validationMsg.classList.add('et-upgrade__validation-msg--visible');
          }
          return;
        }
      }

      var items = [];

      if (selectedSetUpgrade) {
        items.push({ id: parseInt(selectedSetUpgrade.variantId, 10), quantity: 1 });
      } else if (mainProductVariantId) {
        items.push({ id: mainProductVariantId, quantity: 1 });
      }

      selectedItems.forEach(function (item) {
        items.push({ id: parseInt(item.variantId, 10), quantity: 1 });
      });

      if (items.length === 0) return;

      ctaBtn.classList.add('et-upgrade__cta--loading');

      fetch(shopifyUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function () {
          ctaBtn.classList.remove('et-upgrade__cta--loading');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var cartButton = document.querySelector('[aria-controls="cart-drawer"], .header__cart-button, [href$="/cart"]');
          if (cartButton) {
            setTimeout(function () { cartButton.click(); }, 100);
          }
          var cartDrawer = document.querySelector('cart-drawer, #cart-drawer, [id*="cart-drawer"]');
          if (cartDrawer) {
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if (typeof cartDrawer.show === 'function') {
              cartDrawer.show();
            } else {
              cartDrawer.setAttribute('open', '');
            }
          }
        })
        .catch(function () {
          ctaBtn.classList.remove('et-upgrade__cta--loading');
        });
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTab(tab.dataset.tab);
      });
    });

    container.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.et-upgrade__add-btn');
      if (addBtn) {
        var product = addBtn.closest('.et-upgrade__product');
        if (product) addItem(product);
        return;
      }

      var removeBtn = e.target.closest('.et-upgrade__remove-btn');
      if (removeBtn) {
        var product = removeBtn.closest('.et-upgrade__product');
        if (product) removeItem(product.dataset.productId);
        return;
      }

      var upgradeBtn = e.target.closest('.et-upgrade__upgrade-btn');
      if (upgradeBtn) {
        var product = upgradeBtn.closest('.et-upgrade__product');
        if (product) selectSetUpgrade(product);
        return;
      }

      var backBtn = e.target.closest('.et-upgrade__back-btn');
      if (backBtn) {
        clearSetUpgrade();
        return;
      }

      var slotRemove = e.target.closest('.et-upgrade__slot-remove');
      if (slotRemove) {
        var removeId = slotRemove.dataset.removeId;
        if (removeId) removeItem(removeId);
        return;
      }

      var colorTrigger = e.target.closest('[data-color-trigger]');
      if (colorTrigger) {
        var dropdown = colorTrigger.closest('[data-color-dropdown]');
        if (dropdown) {
          container.querySelectorAll('[data-color-dropdown]').forEach(function (d) {
            if (d !== dropdown) d.classList.remove('et-upgrade__color-dropdown--open');
          });
          dropdown.classList.toggle('et-upgrade__color-dropdown--open');
        }
        return;
      }

      var colorOption = e.target.closest('[data-color-select]');
      if (colorOption) {
        var card = colorOption.closest('.et-upgrade__product');
        var dropdown = colorOption.closest('[data-color-dropdown]');
        if (card && dropdown) {
          var oldId = card.dataset.productId;
          card.dataset.productId = colorOption.dataset.swapProductId;
          card.dataset.variantId = colorOption.dataset.swapVariantId;
          card.dataset.productTitle = colorOption.dataset.swapTitle;
          card.dataset.productPrice = colorOption.dataset.swapPrice;
          card.dataset.comparePrice = colorOption.dataset.swapComparePrice;
          card.dataset.productImage = colorOption.dataset.swapImage;

          var cardImg = card.querySelector('.et-upgrade__product-image');
          if (cardImg && colorOption.dataset.swapThumb) {
            cardImg.src = colorOption.dataset.swapThumb;
            cardImg.alt = colorOption.dataset.swapTitle;
          }

          var cardName = card.querySelector('.et-upgrade__product-name');
          if (cardName) cardName.textContent = colorOption.dataset.swapTitle;

          var priceVal = parseInt(colorOption.dataset.swapPrice, 10);
          var compareVal = parseInt(colorOption.dataset.swapComparePrice, 10) || 0;
          var pricesDiv = card.querySelector('.et-upgrade__product-prices');
          if (pricesDiv) {
            if (compareVal > priceVal) {
              pricesDiv.innerHTML =
                '<span class="et-upgrade__product-compare">' + formatMoney(compareVal) + '</span>' +
                '<span class="et-upgrade__product-price et-upgrade__product-price--sale">' + formatMoney(priceVal) + '</span>';
            } else {
              pricesDiv.innerHTML =
                '<span class="et-upgrade__product-price">' + formatMoney(priceVal) + '</span>';
            }
          }

          var triggerSwatch = dropdown.querySelector('.et-upgrade__color-trigger .et-upgrade__color-swatch');
          if (triggerSwatch && colorOption.dataset.colorHex) {
            triggerSwatch.style.backgroundColor = colorOption.dataset.colorHex;
          }
          var triggerLabel = dropdown.querySelector('[data-color-current-label]');
          if (triggerLabel && colorOption.dataset.colorLabel) {
            triggerLabel.textContent = colorOption.dataset.colorLabel;
          }

          dropdown.querySelectorAll('[data-color-select]').forEach(function (o) {
            o.classList.remove('et-upgrade__color-option--active');
          });
          colorOption.classList.add('et-upgrade__color-option--active');

          dropdown.classList.remove('et-upgrade__color-dropdown--open');

          var idx = selectedItems.findIndex(function (i) { return i.id === oldId; });
          if (idx !== -1) {
            selectedItems[idx] = {
              id: colorOption.dataset.swapProductId,
              variantId: colorOption.dataset.swapVariantId,
              title: colorOption.dataset.swapTitle,
              price: priceVal,
              comparePrice: compareVal,
              image: colorOption.dataset.swapImage
            };
            updateSummary();
          }

          updateProductButtons();
        }
        return;
      }

      var ctaTarget = e.target.closest('[data-cta-btn]');
      if (ctaTarget) {
        handleCtaClick();
        return;
      }
    });

    document.addEventListener('click', function (e) {
      // Synthetic events (bots, in-app browsers) can target document or a text node, which have no closest().
      if (!(e.target instanceof Element)) return;
      if (!e.target.closest('[data-color-dropdown]')) {
        container.querySelectorAll('[data-color-dropdown]').forEach(function (d) {
          d.classList.remove('et-upgrade__color-dropdown--open');
        });
      }
    });

    container.addEventListener('change', function (e) {
      var variantSelect = e.target.closest('[data-variant-select]');
      if (!variantSelect) return;

      var card = variantSelect.closest('.et-upgrade__product');
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (!card || !opt) return;

      var oldId = card.dataset.productId;
      card.dataset.productId = opt.dataset.swapProductId;
      card.dataset.variantId = opt.dataset.swapVariantId;
      card.dataset.productTitle = opt.dataset.swapTitle;
      card.dataset.productPrice = opt.dataset.swapPrice;
      card.dataset.comparePrice = opt.dataset.swapComparePrice;
      card.dataset.productImage = opt.dataset.swapImage;

      var cardImg = card.querySelector('.et-upgrade__product-image');
      if (cardImg && opt.dataset.swapThumb) {
        cardImg.src = opt.dataset.swapThumb;
        cardImg.alt = opt.dataset.swapTitle;
      }

      var cardName = card.querySelector('.et-upgrade__product-name');
      if (cardName) cardName.textContent = opt.dataset.swapTitle;

      var priceVal = parseInt(opt.dataset.swapPrice, 10);
      var compareVal = parseInt(opt.dataset.swapComparePrice, 10) || 0;
      var pricesDiv = card.querySelector('.et-upgrade__product-prices');
      if (pricesDiv) {
        if (compareVal > priceVal) {
          pricesDiv.innerHTML =
            '<span class="et-upgrade__product-compare">' + formatMoney(compareVal) + '</span>' +
            '<span class="et-upgrade__product-price et-upgrade__product-price--sale">' + formatMoney(priceVal) + '</span>';
        } else {
          pricesDiv.innerHTML =
            '<span class="et-upgrade__product-price">' + formatMoney(priceVal) + '</span>';
        }
      }

      var idx = selectedItems.findIndex(function (i) { return i.id === oldId; });
      if (idx !== -1) {
        selectedItems[idx] = {
          id: opt.dataset.swapProductId,
          variantId: opt.dataset.swapVariantId,
          title: opt.dataset.swapTitle,
          price: priceVal,
          comparePrice: compareVal,
          image: opt.dataset.swapImage
        };
        updateSummary();
      }

      updateProductButtons();
    });

    updateSummary();
  }

  function initAll() {
    document.querySelectorAll('.et-upgrade').forEach(init);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.et-upgrade');
    if (!section) section = e.target.closest('.et-upgrade');
    if (section) {
      section.removeAttribute('data-et-upgrade-init');
      init(section);
    }
  });

  window.initEtUpgradeSection = function (root) {
    var scope = root || document;
    var sections = [];

    if (scope.classList && scope.classList.contains('et-upgrade')) {
      sections = [scope];
    } else if (scope.querySelectorAll) {
      sections = Array.prototype.slice.call(scope.querySelectorAll('.et-upgrade'));
    }

    sections.forEach(function (el) {
      el.removeAttribute('data-et-upgrade-init');
      init(el);
    });
  };
})();
